var isHttpErrorStatusCode = function isHttpErrorStatusCode(statusCode) {
  if (typeof statusCode !== 'number') {
    return false;
  }
  return statusCode >= 400 && statusCode < 600;
};

export { isHttpErrorStatusCode };
